import { AxiosRepository } from "../../../index";
import AuthClient from "./AuthClient";
export var Versions;
(function (Versions) {
    Versions["v1"] = "v1";
})(Versions || (Versions = {}));
const authApiBaseUrl = process.env.REACT_APP_FTL_AUTH_BASE_URL
    ? process.env.REACT_APP_FTL_AUTH_BASE_URL
    : "http://localhost:9102";
const apiBaseUrl = process.env.REACT_APP_FTL_CRM_BASE_URL
    ? process.env.REACT_APP_FTL_CRM_BASE_URL
    : "http://localhost:42069";
const baseUrl = process.env.REACT_APP_ENV === "dev"
    ? `${apiBaseUrl}/api/${Versions.v1}`
    : `${apiBaseUrl}/api/${Versions.v1}`;
const repository = AxiosRepository({
    baseUrl,
    tokenRefresh: () => AuthAPI.refresh(),
});
export const AuthAPI = new AuthClient(repository, {
    signIn: `${authApiBaseUrl}/not-secure/api/v1/auth/login/email`,
    signOut: `${authApiBaseUrl}/not-secure/api/v1/auth/logout`,
    refresh: `${authApiBaseUrl}/not-secure/api/v1/auth/refresh`,
}, {
    loginPropName: "email",
});
//# sourceMappingURL=AuthAPI.js.map